module.exports = __webpack_public_path__ + "static/media/Poppins-Black.3e72d4e3.woff";